import { ApiService } from '../../../../../services/api.service';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
var BuyerFormComponent = (function () {
    function BuyerFormComponent(formBuilder, apiService, translateService) {
        this.formBuilder = formBuilder;
        this.apiService = apiService;
        this.translateService = translateService;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.username = localStorage.getItem('username');
        this.isBuyerHeadOffice = false;
        this.refreshDropdown = false;
    }
    BuyerFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translateService.onLangChange.subscribe(function () {
            _this.translateDropdown();
        });
        this.createBuyerForm();
        // any time the inner form changes update the parent of any change
        this.createSubscriptions();
        this.getCountries();
        this.getBuyer();
    };
    BuyerFormComponent.prototype.translateDropdown = function () {
        var _this = this;
        this.refreshDropdown = true;
        setTimeout(function () {
            _this.refreshDropdown = false;
        }, 1);
    };
    Object.defineProperty(BuyerFormComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    BuyerFormComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    BuyerFormComponent.prototype.writeValue = function (value) {
        if (value) {
            this.buyerForm.setValue(value);
            this.onChange(value);
            this.onTouched();
        }
    };
    BuyerFormComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    BuyerFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    // communicate the inner form validation to the parent form
    BuyerFormComponent.prototype.validate = function (_control) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.buyerForm.valid ? resolve(null) : resolve({ buyerForm: { valid: false } });
        });
    };
    BuyerFormComponent.prototype.createSubscriptions = function () {
        var _this = this;
        // Subscribe to valueChanges and statusChanges
        this.subscription = combineLatest([this.buyerForm.valueChanges, this.buyerForm.statusChanges]).subscribe(function () {
            _this.onChange(_this.buyerForm.getRawValue());
            _this.onTouched();
        });
    };
    BuyerFormComponent.prototype.getBuyer = function () {
        var _this = this;
        this.apiService.getNewBuyer().subscribe(function (res) {
            _this.buyers = res || [];
            if (_this.branchID) {
                var customer = _this.buyers.find(function (buyer) { return !!(buyer.branch.find(function (branch) { return branch.id.toString() === _this.branchID; })); });
                _this.setBuyer(customer);
            }
            else if (_this.buyers.length === 1) {
                _this.setBuyer(_this.buyers[0]);
            }
        });
    };
    BuyerFormComponent.prototype.getCountries = function () {
        var _this = this;
        this.apiService.getCountry().subscribe(function (res) {
            _this.countries = res;
        });
    };
    BuyerFormComponent.prototype.createBuyerForm = function () {
        this.buyerForm = this.formBuilder.group({
            name: [null, Validators.required],
            taxID: [null],
            branchCode: [null],
            branchName: [null],
            address: [null, Validators.required],
            postalCode: [null, Validators.required],
            country: ['TH', Validators.required],
            email: [null],
            ccEmail: [null]
        });
    };
    Object.defineProperty(BuyerFormComponent.prototype, "buyerBranches", {
        get: function () {
            var _this = this;
            var buyer = this.buyers ? this.buyers.find(function (buyerItem) { return buyerItem.name === _this.buyerName.value; }) : null;
            return buyer ? buyer.branch : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerName", {
        get: function () {
            return this.buyerForm.get('name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerTaxID", {
        get: function () {
            return this.buyerForm.get('taxID');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerBranchCode", {
        get: function () {
            return this.buyerForm.get('branchCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerBranchName", {
        get: function () {
            return this.buyerForm.get('branchName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerAddress", {
        get: function () {
            return this.buyerForm.get('address');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerPostalCode", {
        get: function () {
            return this.buyerForm.get('postalCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerCountry", {
        get: function () {
            return this.buyerForm.get('country');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerEmail", {
        get: function () {
            return this.buyerForm.get('email');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuyerFormComponent.prototype, "buyerCcEmail", {
        get: function () {
            return this.buyerForm.get('ccEmail');
        },
        enumerable: true,
        configurable: true
    });
    BuyerFormComponent.prototype.setBuyer = function (buyer) {
        var _this = this;
        if (this.buyers.includes(buyer)) {
            var name_1 = buyer.name;
            var taxID = buyer.tax_id;
            this.buyerName.setValue(name_1);
            this.buyerTaxID.setValue(taxID);
            this.setBuyerBranch(null);
            if (buyer.branch.length === 1) {
                this.setBuyerBranch(buyer.branch[0]);
            }
        }
        else if (buyer.tax_id.length === 13) {
            this.buyerName.setValue(null);
            this.setBuyerBranch(null);
            this.apiService.getExternalBuyerData({ 'tax_id': buyer.tax_id }).subscribe(function (result) {
                if (result) {
                    _this.buyerName.setValue(result.name);
                    _this.buyerForm.patchValue({
                        address: result.address,
                        country: 'TH',
                        postalCode: result.post_code
                    });
                }
            }, function (error) { });
        }
    };
    BuyerFormComponent.prototype.setBuyerBranch = function (branch) {
        if (this.buyerBranches.includes(branch) || !branch) {
            var branchCode = branch ? branch.branch_code : null;
            var branchName = branch ? branch.branch_name : null;
            var address = branch ? branch.address : null;
            var postalCode = branch ? branch.post_code : null;
            var country = branch ? branch.country_code : null;
            var email = branch ? branch.email : null;
            var ccEmail = branch ? branch.cc_email : null;
            this.buyerForm.patchValue({
                branchCode: branchCode,
                branchName: branchName,
                address: address,
                postalCode: postalCode,
                country: country,
                email: email,
                ccEmail: ccEmail
            });
        }
        else if (this.buyerBranchCode.value === '00000') {
            this.buyerBranchName.setValue('HQ');
        }
        this.isBuyerHeadOffice = this.buyerBranchCode.value === '00000';
        this.isBuyerHeadOffice ? this.buyerBranchName.disable() : this.buyerBranchName.enable();
    };
    BuyerFormComponent.prototype.setBuyerHeadOffice = function () {
        if (this.isBuyerHeadOffice) {
            var branch = this.buyerBranches.find(function (buyerBranche) { return buyerBranche.branch_code === '00000'; });
            if (branch) {
                this.setBuyerBranch(branch);
            }
            else {
                this.buyerBranchCode.setValue('00000');
                this.buyerBranchName.setValue('HQ');
            }
            this.buyerBranchName.disable();
        }
        else {
            this.setBuyerBranch(null);
            this.buyerBranchName.enable();
        }
    };
    return BuyerFormComponent;
}());
export { BuyerFormComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/buyer-form/buyer-form.component.ts.pre-build-optimizer.js